import React, { useEffect } from "react";

import Nav from "../components/Nav";
import data from "../faq.json";

const { intro, items } = data as {
  intro: string;
  items: { question: string; answer: string }[];
};

export default function Faq() {
  useEffect(() => {
    const prev = document.title;
    document.title = "FAQ | Lab Radical";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="min-h-screen bg-bg text-text">
      <Nav />
      <main className="container mx-auto max-w-3xl px-6 pb-40 pt-20">
        <h1 className="font-heading text-[clamp(28px,4vw,40px)] font-bold leading-tight -tracking-[0.03em]">
          Frequently asked questions
        </h1>
        <p className="mt-6 text-[14px] font-light leading-[1.75] text-muted">
          {intro}
        </p>
        {items.map((it) => (
          <section key={it.question} className="mt-12">
            <h2 className="font-heading text-[18px] font-bold -tracking-[0.02em]">
              {it.question}
            </h2>
            <p className="mt-3 text-[14px] font-light leading-[1.75] text-muted">
              {it.answer}
            </p>
          </section>
        ))}
        <div className="mt-16 border-t border-border pt-8">
          <p className="text-[14px] text-text">
            Not sure yet? Email{" "}
            <a
              href="mailto:hello@labradical.com.au"
              className="text-lime underline transition-opacity hover:opacity-80"
            >
              hello@labradical.com.au
            </a>{" "}
            and I'll answer any question in plain English.
          </p>
          <p className="mt-6 text-[12px] text-muted">
            Lab Radical · ABN 59 662 867 813 · hello@labradical.com.au
          </p>
        </div>
      </main>
    </div>
  );
}
